// Harus sama dengan PAKASIR_METHODS di apps/api/src/services/pakasir.ts (API v2).
export type PaymentMethodId =
  | 'qris'
  | 'bri_va'
  | 'bni_va'
  | 'cimb_niaga_va'
  | 'danamon_va'
  | 'maybank_va'
  | 'bnc_va'
  | 'bsi_va'
  | 'muamalat_va'
  | 'ocbc_va';

export const PAYMENT_METHODS: { id: PaymentMethodId; label: string; group: 'qris' | 'va' }[] = [
  { id: 'qris',          label: 'QRIS — semua e-wallet & m-banking', group: 'qris' },
  { id: 'bri_va',        label: 'BRI Virtual Account',               group: 'va' },
  { id: 'bni_va',        label: 'BNI Virtual Account',               group: 'va' },
  { id: 'bsi_va',        label: 'BSI Virtual Account',               group: 'va' },
  { id: 'cimb_niaga_va', label: 'CIMB Niaga Virtual Account',        group: 'va' },
  { id: 'danamon_va',    label: 'Danamon Virtual Account',           group: 'va' },
  { id: 'maybank_va',    label: 'Maybank Virtual Account',           group: 'va' },
  { id: 'muamalat_va',   label: 'Muamalat Virtual Account',          group: 'va' },
  { id: 'ocbc_va',       label: 'OCBC Virtual Account',              group: 'va' },
  { id: 'bnc_va',        label: 'Bank Neo Commerce Virtual Account', group: 'va' },
];

export const methodLabel = (id: string): string =>
  PAYMENT_METHODS.find((m) => m.id === id)?.label ?? id.toUpperCase();

// Kode unik pembayaran — dibangkitkan ACAK di server saat order dibuat
// (apps/api/src/domains/orders/service.ts: MIN/MAX_PAYMENT_ADMIN_FEE), sehingga
// nilai persisnya memang tidak bisa dihitung di klien. Rentangnya diduplikasi di
// sini HANYA untuk keperluan tampilan, supaya halaman order bisa menyebut estimasi
// total yang jujur alih-alih memunculkan angka lebih besar setelah pembeli commit.
// Kalau rentang di API berubah, ubah juga di sini.
export const PAYMENT_ADMIN_FEE_MIN = 2000;
export const PAYMENT_ADMIN_FEE_MAX = 2500;

// QRIS direkomendasikan untuk SEMUA produk (keputusan user 2026-06-13) —
// signature dipertahankan agar pemanggil tidak perlu berubah.
export function recommendedMethod(_orderType?: string, _productSlug?: string): PaymentMethodId {
  return 'qris';
}
